import React from 'react';

import styles from './Page.module.css';

const Page: React.FC = (props) => {
  return <div className={styles.page} {...props} />;
};

export default Page;
